import React from 'react'

type FormProps = React.FormHTMLAttributes<HTMLFormElement>

export const Form: React.FC<FormProps> = (props) => {
  const { children, ...formProps } = props
  return <form {...formProps}>{children}</form>
}
